import state from './moduleCloudinaryState.js'
import mutations from './moduleCloudinaryMutations.js'
import actions from './moduleCloudinaryActions.js'
import getters from './moduleCloudinaryGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
